import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

function LandingPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect logged-in users to /app
  useEffect(() => {
    if (!loading && user) {
      navigate("/app", { replace: true });
    }
  }, [loading, user, navigate]);

  // Show nothing while checking auth state
  if (loading || user) {
    return null;
  }

  return (
    <div className="landing-page">
      {/* Navbar */}
      <nav className="landing-nav">
        <div className="landing-nav-inner">
          <Link to="/" className="landing-logo">DeepSearch</Link>
          <div className="landing-nav-actions">
            <button
              className="btn btn-outline"
              onClick={() => navigate("/auth?mode=login")}
            >
              登录
            </button>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/auth?mode=register")}
            >
              免费注册
            </button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="landing-hero">
        <h1 className="landing-hero-title">
          AI 驱动的深度研究平台
        </h1>
        <p className="landing-hero-subtitle">
          输入你的问题，AI 将自动搜索、分析、综合信息，
          <br />
          生成结构化的研究报告，让复杂研究变得简单高效
        </p>
        <button
          className="btn btn-primary landing-cta"
          onClick={() => navigate("/auth?mode=register")}
        >
          开始深度研究
        </button>
      </section>

      {/* Features */}
      <section className="landing-features">
        <div className="landing-features-inner">
          <h2 className="landing-features-title">核心能力</h2>
          <div className="landing-features-grid">
            <div className="landing-feature-card">
              <div className="landing-feature-icon">🔍</div>
              <h3>智能搜索</h3>
              <p>多源并发搜索，覆盖全网信息，自动过滤噪音，精准定位关键内容</p>
            </div>
            <div className="landing-feature-card">
              <div className="landing-feature-icon">📈</div>
              <h3>图表可视化</h3>
              <p>AI 自动生成数据图表和可视化图形，直观展示分析结果，让复杂数据一目了然</p>
            </div>
            <div className="landing-feature-card">
              <div className="landing-feature-icon">📊</div>
              <h3>报告生成</h3>
              <p>自动生成结构化研究报告，支持图表可视化，结果清晰可追溯</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} DeepSearch. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default LandingPage;
